/** Orden alfabético español (case/accent insensitive) por `nombre` o `label`. */
export function sortByNombre<T extends { nombre?: string | null; label?: string | null }>(
  items: T[],
): T[] {
  return [...items].sort((a, b) => {
    const left = (a.nombre ?? a.label ?? '').toString();
    const right = (b.nombre ?? b.label ?? '').toString();
    return left.localeCompare(right, 'es', { sensitivity: 'base' });
  });
}
